import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';

const CircuitDataBox = ({ circuit }) => {
    const [loading, setLoading] = useState(true);
    const [circuitId, setCircuitId] = useState(circuit);
    const [circuitData, setCircuitData] = useState([]);

    useEffect(() => {
        fetch(`${wp_ajax.db_ajax_url}?action=fetch_database_circuit_data_box&circuit_id=${circuitId}`)
            .then(res => res.json())
            .then(response => {
                setCircuitData(response.data);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return <Loader />;
    }

    const toggleViewMore = e => {
        e.preventDefault();
        e.target.closest('.toggle').classList.toggle('open');
    };

    return (
        <div className="database-data proxima toggle">
            <div className="database-data__wrapper">
                {circuitData.official_name && (
                    <>
                        <div className="database-data__head">Official Name</div>
                        <div className="database-data__content">{circuitData.official_name}</div>
                    </>
                )}
                {circuitData.nationality && (
                    <>
                        <div className="database-data__head">Country</div>
                        <div className="database-data__content database-data__icon"
                             dangerouslySetInnerHTML={{ __html: circuitData.nationality }}></div>
                    </>
                )}
                {circuitData.location && (
                    <>
                        <div className="database-data__head">Location</div>
                        <div className="database-data__content">{circuitData.location}</div>
                    </>
                )}
                {circuitData.co_ordinates && (
                    <>
                        <div className="database-data__head">Co-ordinates</div>
                        <div className="database-data__content">{circuitData.co_ordinates}</div>
                    </>
                )}
                {circuitData.latest_race && (
                    <>
                        <div className="database-data__head">Latest Race</div>
                        <div className="database-data__content">
                            <a href={circuitData.latest_race.url}>
                                {circuitData.latest_race.post_title}
                            </a>
                        </div>
                    </>
                )}
                {circuitData.first_race && (
                    <>
                        <div className="database-data__head">First Race</div>
                        <div className="database-data__content">
                            <a href={circuitData.first_race.url}>
                                {circuitData.first_race.post_title}
                            </a>
                        </div>
                    </>
                )}
                {circuitData.next_race && (
                    <>
                        <div className="database-data__head">Next Race</div>
                        <div className="database-data__content">
                            <a href={circuitData.next_race.url}>
                                {circuitData.next_race.post_title}
                            </a>
                        </div>
                    </>
                )}
                <div className="database-data__expand">
                    <a href="#" className="database-data__more" onClick={toggleViewMore}>View More</a>
                    <a href="#" className="database-data__less" onClick={toggleViewMore}>View Less</a>
                </div>
            </div>
        </div>
    );
};

export default CircuitDataBox;
